import { GET_ALL_STORES, GET_STORE } from './ApiConstants';
import api from './ApiHandler';

export const getStoresByPage = async (payload: any) => {
  return await api.get(GET_ALL_STORES, { params: payload });
};

export const getStore = async (payload: any) => {
  return await api.get(GET_STORE, { params: payload });
};
